import Module from "./Module.vue";
import WelcomePage from "./views/WelcomePage.vue";
import RegisterStep1 from "./views/RegisterStep1.vue";
import RegisterStep2 from "./views/RegisterStep2.vue";
import RegisterStep3 from "./views/RegisterStep3.vue";
import Pembayaran from "./views/Pembayaran.vue";
import ListPerangkat from "./views/ListPerangkat.vue";
import WaConnectIndex from "./views/wa-connect/IndexPage.vue";
import WaConnectOnSite from "./views/wa-connect/OnSite.vue";
import WaConnectOffSite from "./views/wa-connect/OffSite.vue";
import WaConnectWebSite from "./views/wa-connect/WebSite.vue";
import DeviceDetail from "./views/DeviceDetail.vue";
import RiwayatPesan from "./views/RiwayatPesan.vue";
import RiwayatPaket from "./views/RiwayatPaket.vue";
import DeviceConnect from "./views/DeviceConnect.vue";
import ListOutlet from "./views/outlet/ListOutlet.vue";
import IntegrasiOutlet from "./views/outlet/IntegrasiOutlet.vue";
import SetDraftPesan from "./views/outlet/SetDraftPesan.vue";
import EditTemplate from "./views/outlet/EditTemplate.vue";

const requireAuth = { requireAuth: true };

const moduleRoute = {
    path: "/wa-autosender",
    component: Module,
    children: [
        {
            path: "",
            name: "wa_autosender.welcome_page",
            component: WelcomePage,
            meta: {
                ...requireAuth,
                accessKey: 'whatsappDevice.read',
            },
        },
        {
            path: "register",
            component: Module,
            children: [
                {
                    path: "",
                    name: "wa_autosender.register.step1",
                    component: RegisterStep1,
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.create',
                    },
                },
                {
                    path: "step-2",
                    name: "wa_autosender.register.step2",
                    component: RegisterStep2,
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.create',
                    },
                },
                {
                    path: "detail-info",
                    name: "wa_autosender.register.detail_info",
                    components: {
                        default: RegisterStep2,
                        dialog: () => {
                            return import("./components/ModalDetailInfo.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.create',
                    },
                },
                {
                    path: "step-3",
                    name: "wa_autosender.register.step3",
                    component: RegisterStep3,
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.create',
                    },
                },
                {
                    path: "det-info",
                    name: "wa_autosender.register.detail_info_step_3",
                    components: {
                        default: RegisterStep3,
                        dialog: () => {
                            return import("./components/ModalDetailInfo.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.create',
                    },
                },
                {
                    path: "register-confirm",
                    name: "wa_autosender.register.confirm",
                    components: {
                        default: RegisterStep3,
                        dialog: () => {
                            return import("./components/ModalConfirmRegister.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.create',
                    },
                },
            ],
        },
        {
            path: "pembayaran/:id_device/:id_bill",
            component: Module,
            children: [
                {
                    path: "",
                    name: "wa_autosender.pembayaran",
                    component: Pembayaran,
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.purchase',
                    },
                },
                {
                    path: "det-pembayaran",
                    name: "wa_autosender.pembayaran.detail_pembayaran",
                    components: {
                        default: Pembayaran,
                        dialog: () => {
                            return import("./components/ModalDetailPembayaran.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'purchase.read',
                    },
                },
            ],
        },
        {
            path: "connect-perangkat/:id_device",
            component: Module,
            children: [
                {
                    path: "",
                    name: "wa_autosender.connect_perangkat",
                    component: WaConnectIndex,
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.update',
                    },
                },
                {
                    path: "on-site",
                    name: "wa_autosender.connect_perangkat.on_site",
                    component: WaConnectOnSite,
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.update',
                    },
                },
                {
                    path: "off-site",
                    name: "wa_autosender.connect_perangkat.off_site",
                    component: WaConnectOffSite,
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.update',
                    },
                },
                {
                    path: "web-site",
                    name: "wa_autosender.connect_perangkat.web_site",
                    component: WaConnectWebSite,
                    meta: null,
                },
                {
                    path: "connected",
                    name: "wa_autosender.connect_perangkat.connected",
                    component: DeviceConnect,
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.update',
                    },
                },
                {
                    path: "confirm-wa-multiple",
                    name: "wa_autosender.connect_perangkat.confirm_wa_multiple",
                    components: {
                        // default: ,
                        dialog: () => {
                            return import("./components/modal/ConfirmWAMultiple.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.update',
                    },
                },

            ],
        },
        {
            path: "daftar-perangkat",
            component: Module,
            children: [
                {
                    path: "",
                    name: "wa_autosender.daftar_perangkat",
                    component: ListPerangkat,
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.read',
                    },
                },
                {
                    path: "confirm-logout/:id_perangkat",
                    name: "wa_autosender.daftar_perangkat.confirm_logout",
                    components: {
                        default: ListPerangkat,
                        dialog: () => {
                            return import("./components/modal/ConfirmLogout.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.delete',
                    },
                },
            ],
        },
        {
            path: "detail-perangkat/:id_device",
            component: Module,
            children: [
                {
                    path: "",
                    name: "wa_autosender.detail_perangkat",
                    component: DeviceDetail,
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.read',
                    },
                },
                {
                    path: "ubah-nomor",
                    name: "wa_autosender.detail_perangkat.ubah_nomor",
                    components: {
                        default: DeviceDetail,
                        dialog: () => {
                            return import("./components/modal/GantiNomor.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.update',
                    },
                },
                {
                    path: "ubah-nama",
                    name: "wa_autosender.detail_perangkat.ubah_nama",
                    components: {
                        default: DeviceDetail,
                        dialog: () => {
                            return import("./components/modal/GantiNama.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.update',
                    },
                },
                {
                    path: "ubah-paket",
                    name: "wa_autosender.detail_perangkat.ubah_paket",
                    components: {
                        default: DeviceDetail,
                        dialog: () => {
                            return import("./components/modal/GantiPaket.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.update',
                    },
                },
                {
                    path: "ubah-renew/:prev_val",
                    name: "wa_autosender.detail_perangkat.ubah_renew",
                    components: {
                        default: DeviceDetail,
                        dialog: () => {
                            return import("./components/modal/SwitchRenew.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.update',
                    },
                },
                {
                    path: "info-renew",
                    name: "wa_autosender.detail_perangkat.info_renew",
                    components: {
                        default: DeviceDetail,
                        dialog: () => {
                            return import("./components/ModalDetailInfo.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.read',
                    },
                },
                {
                    path: "confirm-delete",
                    name: "wa_autosender.detail_perangkat.confirm_delete",
                    components: {
                        default: DeviceDetail,
                        dialog: () => {
                            return import("./components/modal/ConfirmDelete.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.delete',
                    },
                },
                {
                    path: "confirm-logout/:id_perangkat",
                    name: "wa_autosender.detail_perangkat.confirm_logout",
                    components: {
                        default: DeviceDetail,
                        dialog: () => {
                            return import("./components/modal/ConfirmLogout.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.delete',
                    },
                },
                {
                    path: "ubah-paket-1",
                    name: "wa_autosender.detail_perangkat.ubah_paket_1",
                    component: RegisterStep2,
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.update',
                    },
                },
                {
                    path: "ubah-paket-2",
                    name: "wa_autosender.detail_perangkat.ubah_paket_2",
                    component: RegisterStep3,
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.update',
                    },
                },
                {
                    path: "ubah-paket-confirm",
                    name: "wa_autosender.detail_perangkat.ubah_paket_confirm",
                    components: {
                        default: RegisterStep3,
                        dialog: () => {
                            return import("./components/modal/ConfirmUbah.vue");
                        },
                    },
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.update',
                    },
                },
                {
                    path: "riwayat-pesan",
                    component: Module,
                    children: [
                        {
                            path: "",
                            name: "wa_autosender.detail_perangkat.riwayat_pesan",
                            component: RiwayatPesan,
                            meta: {
                                ...requireAuth,
                                accessKey: 'whatsappDevice.messageHistory',
                            },
                        },
                        {
                            path: "search",
                            name: "wa_autosender.detail_perangkat.riwayat_pesan.search_number",
                            components: {
                                default: RiwayatPesan,
                                dialog: () => {
                                    return import("./components/modal/SearchNumber.vue");
                                },
                            },
                            meta: {
                                ...requireAuth,
                                accessKey: 'messageHistory.read',
                            },
                        },
                        {
                            path: "detail-message/:id_message",
                            name: "wa_autosender.detail_perangkat.riwayat_pesan.detail_message",
                            components: {
                                default: RiwayatPesan,
                                dialog: () => {
                                    return import("./components/modal/DetailMessage.vue");
                                },
                            },
                            meta: {
                                ...requireAuth,
                                accessKey: 'messageHistory.read',
                            },
                        },
                        {
                            path: "resend-message",
                            name: "wa_autosender.detail_perangkat.riwayat_pesan.resend_message",
                            components: {
                                default: RiwayatPesan,
                                dialog: () => {
                                    return import("./components/modal/ConfirmResendMessage.vue");
                                },
                            },
                            meta: {
                                ...requireAuth,
                                accessKey: 'messageHistory.read',
                            },
                        },
                    ],
                },
                {
                    path: "riwayat-paket",
                    name: "wa_autosender.detail_perangkat.riwayat_paket",
                    component: RiwayatPaket,
                    meta: {
                        ...requireAuth,
                        accessKey: 'whatsappDevice.read',
                    },
                },
                {
                    path: "daftar-outlet",
                    component: Module,
                    children: [
                        {
                            path: "",
                            name: "wa_autosender.detail_perangkat.daftar_oulet",
                            component: ListOutlet,
                            meta: {
                                ...requireAuth,
                                accessKey: 'whatsappDevice.integratedOutlet',
                            },
                        },
                        {
                            path: "show-perangkat",
                            name: "wa_autosender.detail_perangkat.daftar_oulet.show_perangkat",
                            components: {
                                default: ListOutlet,
                                dialog: () => {
                                    return import("./components/modal/PilihPerangkatOutlet.vue");
                                },
                            },
                            meta: {
                                ...requireAuth,
                                accessKey: 'integratedOutlet.read',
                            },
                        },
                        {
                            path: "integrasi",
                            name: "wa_autosender.detail_perangkat.daftar_oulet.integrasi",
                            component: IntegrasiOutlet,
                            meta: {
                                ...requireAuth,
                                accessKey: 'integratedOutlet.create',
                            },
                        },
                        {
                            path: "pilih-perangkat",
                            name: "wa_autosender.detail_perangkat.daftar_oulet.pilih_perangkat",
                            components: {
                                default: IntegrasiOutlet,
                                dialog: () => {
                                    return import("./components/modal/PilihPerangkat.vue");
                                },
                            },
                            meta: {
                                ...requireAuth,
                                accessKey: 'integratedOutlet.update',
                            },
                        },
                        {
                            path: "pilih-outlet",
                            name: "wa_autosender.detail_perangkat.daftar_oulet.pilih_outlet",
                            components: {
                                default: IntegrasiOutlet,
                                dialog: () => {
                                    return import("./components/modal/PilihOutlet.vue");
                                },
                            },
                            meta: {
                                ...requireAuth,
                                accessKey: 'integratedOutlet.update',
                            },
                        },
                        {
                            path: "set-draft/:id_outlet",
                            component: Module,
                            children: [
                                {
                                    path: "",
                                    name: "wa_autosender.detail_perangkat.daftar_oulet.set_draft",
                                    component: SetDraftPesan,
                                    meta: {
                                        ...requireAuth,
                                        accessKey: 'integratedOutlet.update',
                                    },
                                },
                                {
                                    path: "switch-device",
                                    name: "wa_autosender.detail_perangkat.daftar_oulet.switch_perangkat",
                                    components: {
                                        default: SetDraftPesan,
                                        dialog: () => {
                                            return import("./components/modal/PilihPerangkatOutlet.vue");
                                        },
                                    },
                                    meta: {
                                        ...requireAuth,
                                        accessKey: 'integratedOutlet.update',
                                    },
                                },
                                {
                                    path: "confirm",
                                    name: "wa_autosender.detail_perangkat.daftar_oulet.confirm_switch_perangkat",
                                    components: {
                                        default: SetDraftPesan,
                                        dialog: () => {
                                            return import("./components/modal/ConfirmSwitchDevice.vue");
                                        },
                                    },
                                    meta: {
                                        ...requireAuth,
                                        accessKey: 'integratedOutlet.update',
                                    },
                                },
                                {
                                    path: "preview-msg",
                                    name: "wa_autosender.detail_perangkat.daftar_oulet.preview_msg",
                                    components: {
                                        default: SetDraftPesan,
                                        dialog: () => {
                                            return import("./components/modal/PreviewMsg.vue");
                                        },
                                    },
                                },
                                {
                                    path: "confirm-unlinked",
                                    name: "wa_autosender.detail_perangkat.daftar_oulet.confirm_unlinked",
                                    components: {
                                        default: SetDraftPesan,
                                        dialog: () => {
                                            return import("./components/modal/ConfirmUnlinked.vue");
                                        },
                                    },
                                    meta: {
                                        ...requireAuth,
                                        accessKey: 'integratedOutlet.delete',
                                    },
                                },
                                {
                                    path: "update-duration",
                                    name: "wa_autosender.detail_perangkat.daftar_oulet.update_duration",
                                    components: {
                                        default: SetDraftPesan,
                                        dialog: () => {
                                            return import("./components/modal/DurationUpdate.vue");
                                        },
                                    },
                                    meta: {
                                        ...requireAuth,
                                        accessKey: 'integratedOutlet.update',
                                    },
                                },
                                {
                                    path: "edit-template",
                                    component: Module,
                                    children: [
                                        {
                                            path: "",
                                            name: "wa_autosender.detail_perangkat.daftar_oulet.edit_template",
                                            component: EditTemplate,
                                            meta: {
                                                ...requireAuth,
                                                accessKey: 'integratedOutlet.update',
                                            },
                                        },
                                        {
                                            path: "panduan",
                                            name: "wa_autosender.detail_perangkat.daftar_oulet.edit_template.panduan",
                                            components: {
                                                default: EditTemplate,
                                                dialog: () => {
                                                    return import("./components/modal/PanduanPenulisan.vue");
                                                },
                                            },
                                        },
                                        {
                                            path: "reset-template",
                                            name:
                                                "wa_autosender.detail_perangkat.daftar_oulet.edit_template.reset_template",
                                            components: {
                                                default: EditTemplate,
                                                dialog: () => {
                                                    return import("./components/modal/ResetTemplate.vue");
                                                },
                                            },
                                            meta: {
                                                ...requireAuth,
                                                accessKey: 'integratedOutlet.update',
                                            },
                                        },
                                        {
                                            path: "confirm-leave",
                                            name:
                                                "wa_autosender.detail_perangkat.daftar_oulet.edit_template.confirm_leave",
                                            components: {
                                                default: EditTemplate,
                                                dialog: () => {
                                                    return import("./components/modal/ConfirmLeave.vue");
                                                },
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
};

export default (router) => {
    router.addRoutes([moduleRoute]);
};
